/**
 * @module
 *
 * @import {Controller} from '@acng/frontend-stargazer';
 */

import {CONNECT} from '@acng/frontend-stargazer';
import {CLICK, on} from '@acng/frontend-bounty/dom/event.js';
import {isMobile} from './service/env.js';
import {goBack} from './service/location.js';

export const navigator = {
  desktop: !isMobile,
  mobile: isMobile,
  /**
   * @type {Controller}
   */
  back: {
    [CONNECT](element) {
      on(element, CLICK, () => goBack());
    },
  },
};
